"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Box = require("grommet/es6/components/Box");

var _utils = require("../../theme/utils");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var secondaryStyle = function secondaryStyle(props) {
  return (0, _styledComponents.css)(["background-color:", ";color:", ";"], props.theme.box.secondary.backgroundColor, props.theme.box.secondary.color);
};

var primaryStyle = function primaryStyle(props) {
  return (0, _styledComponents.css)(["background-color:", ";color:", ";"], props.theme.box.primary.backgroundColor, props.theme.box.primary.color);
};

var defaultStyle = function defaultStyle(props) {
  return (0, _styledComponents.css)(["background-color:", ";color:", ";"], props.theme.box["default"].backgroundColor, props.theme.box["default"].color);
};

var ExtendedBox = (0, _styledComponents["default"])(_Box.Box).withConfig({
  displayName: "Box__ExtendedBox",
  componentId: "sc-4r7uyw-0"
})(["", " ", " ", " ", " ", " ", ""], function (props) {
  return !props.background && defaultStyle;
}, function (props) {
  return props.primary && primaryStyle(props);
}, function (props) {
  return props.secondary && secondaryStyle(props);
}, function (props) {
  return props.background && (0, _styledComponents.css)(["background-color:", ""], props.background);
}, function (props) {
  return props.background && props.hoverEffect && (0, _styledComponents.css)(["&:hover{}"]);
}, function (props) {
  return props.background && props.hoverEffect && (0, _styledComponents.css)(["&:hover{cursor:pointer;background-color:", ";}"], (0, _utils.fadeColor)(props.background, 20));
});

var Box = function Box(props) {
  var forwardRef = props.forwardRef,
      rest = _objectWithoutProperties(props, ["forwardRef"]);

  return /*#__PURE__*/_react["default"].createElement(ExtendedBox, _extends({
    ref: forwardRef
  }, rest));
}; // const Box = (props) => <ExtendedBox {...props} />;


var _default = Box;
exports["default"] = _default;